import { render } from "./UserPortfolioDescription.vue?vue&type=template&id=31269680&scoped=true"
import script from "./UserPortfolioDescription.vue?vue&type=script&lang=js"
export * from "./UserPortfolioDescription.vue?vue&type=script&lang=js"

import "./UserPortfolioDescription.vue?vue&type=style&index=0&id=31269680&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31269680"],['__file',"src/scripts/view/portfolio/common/user/UserPortfolioDescription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31269680"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31269680', __exports__)) {
    api.reload('31269680', __exports__)
  }
  
  module.hot.accept("./UserPortfolioDescription.vue?vue&type=template&id=31269680&scoped=true", () => {
    api.rerender('31269680', render)
  })

}


export default __exports__